module.exports = __webpack_public_path__ + "static/img/dp_cloud.c7ca49cb.svg";